export default "__VITE_ASSET__6JA0CYj5__"